
import { createAsyncThunk } from "@reduxjs/toolkit";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { userService } from "@/services/api/cresivoxServer";
import { REDUCER_NAME } from "./Types";


const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const getDeletedUsersList = createAsyncThunk(
  curriedGetThunkName("getDeletedUsersList"),
  async (_, { rejectWithValue }) => {
    try {
      const response = await userService.getDeletedUsersList();
    //   console.log(" full response:", response);

      if (response) {
        const { httpStatusCode, data, message } = response;
        // console.log(" httpStatusCode:", httpStatusCode);
        // console.log(" data:", data);

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            const responseData = data?.data || data;
            // console.log(" ~ responseData:", responseData);

            if (responseData) {
              return {
                data: {
                  users: Array.isArray(responseData)
                    ? responseData
                    : responseData.users || responseData.data || [],
                  message,
                }
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
    //   console.log(" ~ error:", error);
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  },
);